import React from 'react';
import { roundFloat } from 'src/core/utils/formater';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

// Импорт: Нэг газраас
import { huuliData } from 'src/data/huuliData';
import { yamList } from 'src/data/yamsData';

/* -------------------------------------------------------------------------- */
/*  Хуулийн дугаар → 22.9.x болгох                                          */
/* -------------------------------------------------------------------------- */
const getHuuliKey = (id) => huuliData[id]?.key || id;

/* -------------------------------------------------------------------------- */
/*  Яамны ID → Нэр болгох                                                   */
/* -------------------------------------------------------------------------- */
const getYamNames = (yamStr) => {
  if (!yamStr) return '-';
  return yamStr
    .split(',')
    .map((y) => y.trim())
    .filter(Boolean)
    .map((y) => yamList[y] || y)
    .join(', ');
};

/* -------------------------------------------------------------------------- */
/*  Заалт → 2 мөр + Tooltip + ...                                          */
/* -------------------------------------------------------------------------- */
const renderZaalt = (text, row) => {
  const item = huuliData[row.huuli_dugaar];
  const fullText = item?.text || text || '-';
  const truncated =
    fullText.length > 100 ? `${fullText.slice(0, 100)}...` : fullText;

  return (
    <div
      style={{
        whiteSpace: 'normal',
        lineHeight: '1.4',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
      title={fullText}
    >
      {truncated}
    </div>
  );
};

/* -------------------------------------------------------------------------- */
/*  customSummary – Нийт дүнгийн мөр                                        */
/* -------------------------------------------------------------------------- */
export const customSummary = [
  { value: null },
  { align: 'left', word: 'Нийт дүн:' },
  { value: null },
  { value: null },
  { value: null },
  { value: null },
  { value: null },
  { align: 'right', value: 'total_olgoson_dun' }, //
  { value: null },
  { value: null },
  { align: 'right', value: 'total_tulbur_dun' }, //
  { value: null },
  { align: 'right', value: 'total_huleen_avgch_too' }, //
  { align: 'right', value: 'total_tailan_dun' }, //
  { align: 'right', value: 'total_total_dun' }, // ЗӨВ: total_zardal_niit_dun → total_dun
  { value: null },
  { value: null },
  { value: null },
];

//  SUM(olgoson_dun::FLOAT) AS total_olgoson_dun,
//   SUM(tulbur_dun::FLOAT) AS total_tulbur_dun,
//   SUM(tailan_dun::FLOAT) AS total_tailan_dun,
//   SUM(huleen_avgch_too::FLOAT) AS total_huleen_avgch_too,
//   SUM(total_dun::FLOAT) AS total_total_dun
/* -------------------------------------------------------------------------- */
/*  customColumns – ТМ-1в хүснэгтийн баганууд                                */
/* -------------------------------------------------------------------------- */
export const customColumns = ({
  customDelete = () => {},
  customEdit = () => {},
}) => [
  /* 1 – Д/Д */
  {
    title: 'Д/Д',
    dataIndex: 'counter',
    align: 'center',
    titleAlign: 'center',
    width: 50,
  },

  /* 2-5 – Харилцан хамааралгүй этгээд */
  {
    title: (
      <div
        style={{ textAlign: 'center', whiteSpace: 'normal', lineHeight: '1.4' }}
      >
        Харилцан хамааралгүй этгээдэд
        <br />
        олгосон санхүүгийн дэмжлэг, хандивын
      </div>
    ),
    titleAlign: 'center',
    children: [
      {
        title: 'олгосон этгээдийн',
        titleAlign: 'center',
        children: [
          {
            title: 'ТТД',
            dataIndex: 'ttd_olgoson',
            align: 'center',
            width: 100,
          },
          { title: 'Нэр', dataIndex: 'ner_olgoson', align: 'left', width: 140 },
        ],
      },
      {
        title: 'хүлээн авсан этгээдийн',
        titleAlign: 'center',
        children: [
          { title: 'ТТД', dataIndex: 'ttd_avsan', align: 'center', width: 100 },
          { title: 'Нэр', dataIndex: 'ner_avsan', align: 'left', width: 140 },
        ],
      },
    ],
  },

  /* 6-7 – Хуулийн заалт */
  {
    title: 'Хуулийн заалт',
    titleAlign: 'center',
    children: [
      {
        title: 'Дугаар',
        dataIndex: 'huuli_dugaar',
        align: 'center',
        titleAlign: 'center',
        width: 90,
        render: (id) => getHuuliKey(id), // 1 → 22.9.1
      },
      {
        title: 'Заалт',
        dataIndex: 'zaalt',
        align: 'left',
        titleAlign: 'center',
        width: 400, // Өргөтгөв
        render: renderZaalt, // 2 мөр + Tooltip
      },
    ],
  },

  /* 8 – Олгосон дүн */
  {
    title: 'Олгосон дүн',
    dataIndex: 'olgoson_dun',
    align: 'right',
    titleAlign: 'center',
    width: 130,
    render: (_, row) => roundFloat(row?.olgoson_dun),
  },

  /* 9-12 – Зарцуулалтын дэлгэрэнгүй */
  {
    title: (
      <div
        style={{ textAlign: 'center', whiteSpace: 'normal', lineHeight: '1.4' }}
      >
        Хүлээн авсан санхүүгийн дэмжлэг,
        <br />
        хандивын зарцуулалтын
      </div>
    ),
    titleAlign: 'center',
    children: [
      /* 9 – Нэр төрөл */
      {
        title: 'Нэр төрөл',
        dataIndex: 'ner_turul',
        align: 'center',
        titleAlign: 'center',
        width: 120,
      },

      /* 10 – Төлбөрийн баримт */
      {
        title: 'Төлбөрийн баримтын',
        titleAlign: 'center',
        children: [
          {
            title: <div style={{ lineHeight: '1.3' }}>Дугаар</div>,
            dataIndex: 'tulbur_dugaar',
            align: 'center',
            titleAlign: 'center',
            width: 110,
          },
          {
            title: 'Дүн',
            dataIndex: 'tulbur_dun',
            align: 'right',
            titleAlign: 'center',
            width: 110,
            render: (_, row) => roundFloat(row?.tulbur_dun),
          },
        ],
      },

      /* 11-12 – Суутган төлөгчийн тайлагнасан зардал */
      {
        title: (
          <div
            style={{
              textAlign: 'center',
              whiteSpace: 'normal',
              lineHeight: '1.3',
            }}
          >
            суутган төлөгчийн
            <br />
            тайлагнасан зардлын
          </div>
        ),
        titleAlign: 'center',
        children: [
          {
            title: 'тайлангийн төрөл',
            dataIndex: 'tailan_turul',
            align: 'center',
            titleAlign: 'center',
            width: 120,
          },
          {
            title: 'орлого хүлээн авагчийн тоо',
            dataIndex: 'huleen_avgch_too',
            align: 'right',
            titleAlign: 'center',
            width: 130,
            render: (_, row) => roundFloat(row?.huleen_avgch_too),
          },
          {
            title: 'Дүн',
            dataIndex: 'tailan_dun',
            align: 'right',
            titleAlign: 'center',
            width: 110,
            render: (_, row) => roundFloat(row?.tailan_dun),
          },
        ],
      },
    ],
  },

  /* 13 – Зарцуулалтын нийт дүн */
  {
    title: (
      <div
        style={{ textAlign: 'center', whiteSpace: 'normal', lineHeight: '1.4' }}
      >
        Зарцуулалтын
        <br />
        нийт дүн
      </div>
    ),
    dataIndex: 'total_dun',
    align: 'right',
    titleAlign: 'center',
    width: 130,
    render: (_, row) => roundFloat(row?.total_dun),
  },

  /* 14 – Хяналт тавих яам */
  {
    title: 'Хяналт тавих яам',
    dataIndex: 'yam',
    align: 'left',
    titleAlign: 'center',
    width: 200,
    render: (yamStr) => getYamNames(yamStr),
  },

  /* 15 – Засах */
  {
    title: 'Засах',
    align: 'center',
    titleAlign: 'center',
    width: 60,
    render: (_, row) => (
      <EditOutlined
        style={{ cursor: 'pointer', color: '#1890ff', fontSize: '16px' }}
        onClick={(e) => {
          e.stopPropagation();
          customEdit(row);
        }}
        title="Засах"
      />
    ),
  },

  /* 16 – Устгах */
  {
    title: 'Устгах',
    align: 'center',
    titleAlign: 'center',
    width: 60,
    render: (_, row) => (
      <DeleteOutlined
        style={{ cursor: 'pointer', color: '#ff4d4f', fontSize: '16px' }}
        onClick={(e) => {
          e.stopPropagation();
          customDelete(row);
        }}
        title="Устгах"
      />
    ),
  },
];
